﻿/* Arranque ligero: decide la alternativa antes de descargar el motor 3D. */
(function () {
  function eachNave(scope, callback) {
    if (scope.matches && scope.matches('ug-nave-3d')) callback(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('ug-nave-3d').forEach(callback);
  }
  if (window.UGNaveBoot) {
    eachNave(document, window.UGNaveBoot.boot);
    return;
  }
  var states = new WeakMap(), webgl2, webglProbe, bundle;
  function registerCache(el) {
    if (!('serviceWorker' in navigator) || !window.isSecureContext) return;
    var local = /^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname);
    var source = local ? '/assets/ug-sw.js' : el.dataset.sw;
    if (!source) return;
    var url = new URL(source, location.href);
    // Shopify CDN assets cannot control the storefront origin. Deployment
    // needs a same-origin endpoint with Service-Worker-Allowed: /.
    if (url.origin !== location.origin) { el.dataset.cache = 'http'; return; }
    navigator.serviceWorker.getRegistration('/').then(function(existing) {
      if (existing && !existing.active?.scriptURL.includes('/ug-sw.js')) { el.dataset.cache='existing-worker'; return; }
      return navigator.serviceWorker.register(url.href, {scope:'/',updateViaCache:'none'});
    }).then(function(registration) {
      if (!registration) return;
      el.dataset.cache = 'sw';
      function prime() {
        var worker = registration.active;
        if (worker) worker.postMessage({type:'ug:prime',urls:[el.dataset.script,el.mainModelUrl||el.dataset.glb].filter(Boolean)});
      }
      if (registration.active) prime();
      else registration.installing?.addEventListener('statechange',function(){if(registration.active)prime();});
      el.addEventListener('ug:nave:ready',prime,{once:true});
    }).catch(function(error) { el.dataset.cache='http';console.info('[ug] caché HTTP; SW no disponible:',error.message); });
  }
  function supportsWebGL2() {
    if (webgl2 !== undefined) return webgl2;
    try {
      var gl = document.createElement('canvas').getContext('webgl2');
      webgl2 = !!gl;
      if (gl) gl.getExtension('WEBGL_lose_context')?.loseContext();
    } catch (_) { webgl2 = false; }
    return webgl2;
  }
  function supportsWebGL2Async() {
    if (webgl2 !== undefined) return Promise.resolve(webgl2);
    if (webglProbe) return webglProbe;
    if (typeof Worker === 'undefined' || typeof OffscreenCanvas === 'undefined') return Promise.resolve(supportsWebGL2());
    // Cold graphics-driver initialization can take >300 ms. Probe in a worker
    // so the cover and input remain responsive; restrictive CSP retains the
    // synchronous capability check, not a false unsupported-device result.
    webglProbe = new Promise(function(resolve) {
      var worker, url, timer, done = false;
      function finish(value) {
        if (done) return; done = true; clearTimeout(timer);
        if (worker) worker.terminate(); if (url) URL.revokeObjectURL(url);
        resolve(value === null ? supportsWebGL2() : (webgl2 = value));
      }
      try {
        url = URL.createObjectURL(new Blob(['onmessage=function(){try{var gl=new OffscreenCanvas(1,1).getContext("webgl2");var ok=!!gl;if(gl){var ext=gl.getExtension("WEBGL_lose_context");if(ext)ext.loseContext();}postMessage(ok?true:null);}catch(e){postMessage(null);}}'], {type:'text/javascript'}));
        worker = new Worker(url); worker.onmessage = function(event) { finish(event.data); };
        worker.onerror = function(event) { event.preventDefault(); finish(null); };
        timer = setTimeout(function(){finish(null);},8000); worker.postMessage(null);
      } catch (_) { finish(null); }
    });
    return webglProbe;
  }
  function fallback(el, reason) {
    if (!el) return 'fallback';
    states.set(el, 'fallback');
    el.dataset.booted = '1';
    el.dataset.renderMode = 'fallback';
    el.dataset.reason = reason || 'carga';
    el.classList.add('ug-nave--fallback');
    el.classList.remove('ug-nave--3d');
    el.removeAttribute('data-intro');
    el.removeAttribute('data-hint');
    el.removeAttribute('data-interior');
    el.removeAttribute('data-entered');
    el.style.setProperty('--ug-progress', '0');
    var loading = el.querySelector('.ug-nave__loading');
    if (loading) loading.hidden = true;
    el.querySelectorAll('[data-stage]').forEach(function (stage) {
      var active = Number(stage.dataset.stage) === 0;
      stage.toggleAttribute('data-active', active);
      stage.inert = !active;
      stage.setAttribute('aria-hidden', String(!active));
    });
    el.ugRecepcion?.hide(true);
    // The Liquid theme supplies this navigation. Local previews have no Liquid
    // but must retain the same useful way into all fifteen normal collections.
    if (/^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname) && !el.querySelector('.ug-nave__fallback-catalog')) {
      var copy = el.querySelector('[data-stage="0"]');
      if (copy) {
        var details = document.createElement('details'), summary = document.createElement('summary'), nav = document.createElement('nav');
        details.className = 'ug-nave__fallback-catalog'; summary.textContent = 'Todas las secciones'; nav.setAttribute('aria-label', 'Todas las secciones');
        ['Control de clima','Riego','Sanidad vegetal','Sustratos','Parafernalia','Cosecha','Extracción','Fertilizantes','Herramientas y accesorios','Iluminación','Instrumentos de medida','Macetas y bandejas','Armarios de cultivo','Tratamiento de olores','Envasado'].forEach(function (name, index) {
          var link = document.createElement('a'); link.href = '/preview/catalogo.html?seccion=' + (index + 1); link.textContent = String(index + 1).padStart(2, '0') + ' · ' + name; nav.appendChild(link);
        });
        details.appendChild(summary); details.appendChild(nav); copy.appendChild(details);
      }
    }
    el.dispatchEvent(new CustomEvent('ug:nave:boot', { detail: { mode: 'fallback', reason: el.dataset.reason } }));
    return 'fallback';
  }
  function loadBundle(el) {
    if (customElements.get('ug-nave-3d') || bundle) return;
    var src = el.dataset.renderMode === 'video' ? el.dataset.videoScript : el.dataset.script;
    if (!src) { fallback(el, 'sin-script'); return; }
    bundle = document.querySelector('script[data-ug-nave-3d]') || document.createElement('script');
    var script = bundle, timeout;
    function failed() {
      clearTimeout(timeout);
      if (bundle !== script) return;
      bundle = null;
      script.remove();
      eachNave(document, function (nave) {
        if (nave.dataset.renderMode === '3d' || nave.dataset.renderMode === 'video') fallback(nave, 'carga-script');
      });
    }
    bundle.addEventListener('error', failed, { once: true });
    bundle.addEventListener('load', function () {
      clearTimeout(timeout);
      if (!customElements.get('ug-nave-3d')) failed();
    }, { once: true });
    timeout = setTimeout(failed, 20000);
    if (!bundle.parentNode) {
      bundle.src = src;
      bundle.defer = true;
      bundle.setAttribute('data-ug-nave-3d', '');
      document.head.appendChild(bundle);
    }
  }
  function preload(src, as) {
    if (!src) return;
    if(Array.from(document.querySelectorAll('link[rel="preload"]')).some(function(l){return l.href===new URL(src,location.href).href&&l.as===as;}))return;
    var link = document.createElement('link');
    link.rel = 'preload'; link.as = as; link.href = src;
    if (as === 'fetch' || as === 'image') link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }
  function startAfterPoster(el) {
    // El sondeo en worker puede coincidir con la decodificación del póster sin
    // bloquear su pintura. El respaldo síncrono sigue esperando a esa pintura.
    var probe = typeof Worker !== 'undefined' && typeof OffscreenCanvas !== 'undefined' ? supportsWebGL2Async() : null;
    async function start() {
      if (!await (probe || supportsWebGL2Async())) { fallback(el, 'sin-webgl2'); return; }
      if (!el.isConnected || states.get(el) !== '3d') return;
      if (poster && typeof requestAnimationFrame === 'function') {
        preload(el.dataset.script, 'script');
        var manifest={};try{manifest=JSON.parse(el.querySelector('script[data-ug-assets]')?.textContent||'{}');}catch(e){}
        var base=new URL(el.dataset.glb,location.href),models=el.dataset.modelsBase;
        var main=el.dataset.modelTransport==='gzip'&&!models?manifest['universo-nave-fase-a.glb.bin']||new URL('universo-nave-fase-a.glb.bin',base).href:el.dataset.glb;
        preload(main,'fetch');
        var files=['ug-raptor.glb','ug-cogollo-01.glb','ug-avioneta.glb','ug-avioneta-lejos.glb'];
        files.push('ug-personaje-rol-01.glb');
        files.forEach(function(file){if(!models&&el.dataset.modelTransport==='gzip')file+='.bin';var src=models?new URL(file,models.replace(/\/?$/,'/')).href:manifest[file]||new URL(file,base).href;preload(src,'fetch');});
        ['ug-env-interior-compacto.bin'].forEach(function(file){preload(manifest[file]||new URL(file,base).href,'fetch');});
        ['ug-avioneta-cartel.webp','ug-tex-dirt_aerial_02-diff.jpg','ug-tex-dirt_aerial_02-nor_gl.jpg','ug-tex-aerial_asphalt_01-diff.jpg','ug-tex-aerial_asphalt_01-nor_gl.jpg'].forEach(function(file){preload(manifest[file]||new URL(file,base).href,'image');});
      }
      loadBundle(el);
    }
    var poster = el.querySelector('.ug-nave__poster');
    if (!poster || typeof requestAnimationFrame !== 'function') { start(); return; }
    // Download in parallel, but let the cover paint before evaluating Three
    // and allocating PMREM/WebGL. Fallback modes never preload the 3D assets.
    var decoded = poster?.decode ? poster.decode().catch(function () {}) : Promise.resolve();
    // A missing/slow poster must not prevent the scene from starting.
    var timeout;
    Promise.race([decoded, new Promise(function(resolve) { timeout = setTimeout(resolve, 300); })]).then(function () {
      clearTimeout(timeout);
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        if (!el.isConnected || states.get(el) !== '3d') return;
        performance.mark('ug:poster-yielded');
        start();
      }); });
    });
  }
  function boot(el) {
    if (!el) return 'fallback';
    if (states.has(el)) return states.get(el);
    var force = new URLSearchParams(location.search).get('ug3d');
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var coarse = matchMedia('(pointer: coarse)').matches;
    var saveData = !!navigator.connection?.saveData;
    // Portada en vídeo (el recorrido grabado): ajuste «Modo de la portada» del tema o ?modo=video|3d para probar.
    var modo = new URLSearchParams(location.search).get('modo') || el.dataset.modo;
    // El vídeo es ligero y vale para cualquier aparato: «reducir movimiento», el ahorro de datos o ser un móvil
    // solo descartan el 3D en tiempo real. (Con «reducir movimiento» el recorrido pasa de parada en parada sin
    // animación: nave-video.js.)
    var ligero = modo === 'video' && !!el.dataset.videoScript;
    var reason = force === 'off' ? 'forzado'
      : force !== 'on' && el.dataset.enabled === 'false' ? 'desactivado'
      : force !== 'on' && !ligero && reduce ? 'reducir-movimiento'
      : force !== 'on' && !ligero && saveData ? 'ahorro-datos'
      : force !== 'on' && !ligero && coarse && el.getAttribute('data-mobile-3d') !== 'true' ? 'movil' : '';
    if (reason) return fallback(el, reason);
    // La portada en vídeo tiene grabación vertical para móviles; los modos mixtos aún no: portada fija.
    if (/^(hibrido|exterior3d|interior3d)$/.test(modo || '') && innerWidth < innerHeight) return fallback(el, 'video-vertical');
    if (modo === 'video' && el.dataset.videoScript) {
      states.set(el, 'video');
      el.dataset.booted = '1';
      el.dataset.renderMode = 'video';
      delete el.dataset.reason;
      el.classList.remove('ug-nave--fallback');
      el.dispatchEvent(new CustomEvent('ug:nave:boot', { detail: { mode: 'video' } }));
      preload(el.dataset.videoScript, 'script');
      loadBundle(el);
      return 'video';
    }
    states.set(el, '3d');
    el.dataset.booted = '1';
    el.dataset.renderMode = '3d';
    delete el.dataset.reason;
    el.classList.remove('ug-nave--fallback');
    el.addEventListener('ug:nave:ready', function () { registerCache(el); }, {once:true});
    el.dispatchEvent(new CustomEvent('ug:nave:boot', { detail: { mode: '3d' } }));
    startAfterPoster(el);
    return states.get(el);
  }
  function dispose(el) {
    states.delete(el);
    delete el.dataset.booted;
    delete el.dataset.renderMode;
  }
  window.UGNaveBoot = { boot: boot, fallback: fallback, dispose: dispose };
  eachNave(document, boot);
  document.addEventListener('shopify:section:load', function (event) { eachNave(event.target, boot); });
  document.addEventListener('shopify:section:unload', function (event) { eachNave(event.target, dispose); });
})();
